var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"map",staticClass:"rounded-4 full m-2",staticStyle:{"width":"98vw","height":"98vh"},attrs:{"id":"google_map"}}),_c('transition',{attrs:{"name":"slide-fade-right"}},[(_vm.legendaState)?_c('app-legenda',{staticClass:"legenda"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }